import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

export const AdminContainer = styled.div`
  display: flex;
  height: 100vh;
`;

export const Sidebar = styled.nav`
  position: fixed;
  width: 250px;
  height: 100vh;
  background-color: #000;
  display: flex;
  flex-direction: column;
  padding: 20px;
`;

export const NavItem = styled(NavLink)`
  display: flex;
  align-items: center;
  gap: 10px;
  color: white;
  text-decoration: none;
  padding: 10px 0;
  font-size: 18px;
  &:hover {
    color: #92b21f;
  }

  &.active {
    color: #92b21f;
  }
`;

export const Logo = styled.img`
  align-self: center;
  width: 100px;
  height: 100px;
  margin-bottom: 20px;
`;

export const LogoutButton = styled(NavLink)`
  display: flex;
  align-items: center;
  color: white;
  justify-self: flex-end;
  text-decoration: none;
  margin-top: auto;
  &:hover {
    color: #92b21f;
  }
`;

export const Content = styled.div`
  flex-grow: 1;
  background-color: #212121;
  padding: 20px 20px 20px 270px;
  overflow-y: auto;
`;
